module.exports = __webpack_public_path__ + "static/sanramon-4e16c40409676cf14e96f9826151fcb4.jpg";